import { createHttpEndpoint } from '../../utils'

/**
 * Retrieve Client billing address
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/billing-address/operation/retrieveClientBillingAddress}
 */
export const getBillingAddress = createHttpEndpoint({
  method: 'GET',
  operationId: 'retrieveClientBillingAddress',
  path: '/bm/client/addresses/billing',
})

/**
 * Create Client billing address
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/billing-address/operation/createClientBillingAddress}
 */
export const postBillingAddress = createHttpEndpoint({
  method: 'POST',
  operationId: 'createClientBillingAddress',
  path: '/bm/client/addresses/billing',
})
